// Compact display copy only. Full descriptions/source occurrences stay intact.
export function nodeSummary(node, entity = {}) {
  if (entity.description_summary) return entity.description_summary;
  if (node.description_summary) return node.description_summary;
  if ((entity.display_name || node.name) === 'GUSTO' && (entity.concept_type || node.concept_type) === 'Cohort') {
    return 'GUSTO is a longitudinal mother–child birth cohort in Singapore, following families from pregnancy through childhood and adolescence.';
  }
  let mentions = entity.source_mentions || [];
  try { if (typeof mentions === 'string') mentions = JSON.parse(mentions); } catch { mentions = []; }
  const context = mentions.find(mention => mention.identity_context)?.identity_context;
  let description = context || node.description || '';
  if (!context && description.includes('Source occurrence (')) {
    description = description.split(/Source occurrence \([^\n]*?\):\s*/)[1] || '';
  }
  description = description.replace(/\s+/g, ' ').trim();
  for (const name of [node.name, node.title, entity.name].filter(Boolean)) {
    if (description.startsWith(`${name}. `)) description = description.slice(name.length + 2);
    if (description.startsWith(`${name}: `)) description = description.slice(name.length + 2);
  }
  description = description.replace(/^Type:\s*[^.]+\.\s*/, '');
  // Avoid displaying multiple source records or an entire extraction payload.
  const sentences = description.match(/.+?(?:[.!?](?=\s|$)|$)/g) || [description];
  description = sentences.slice(0, 2).join('').trim();
  if (description.length > 360) description = `${description.slice(0, 357).replace(/\s+\S*$/, '')}…`;
  return description;
}
